"use client";

// packages/eden-text/src/components/Text3.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var Container3 = styled.div`
  font: var(--unity-text3-body);
  ${shared};
  ${({ $emphasized }) => $emphasized ? "font: var(--unity-text3-body-emphasized)" : ""};
  ${({ $long }) => $long ? "font: var(--unity-text3-body-long)" : ""};
  ${({ $emphasized, $long }) => $emphasized && $long ? "font: var(--unity-text3-body-long-emphasized)" : ""};
`;
var Text3 = ({ children, renderAs = "div", emphasized, long, ...props }) => /* @__PURE__ */ jsx(Container3, { as: renderAs, $emphasized: emphasized, $long: long, ...props, children });
Text3.displayName = "Text3";
var Text3_default = Text3;
export {
  Text3_default as default
};
